export const alignFull = () => {
  function setAlignFullCssVar() {
    // Create the measurement node
    const scrollDiv = document.createElement('div');
    scrollDiv.className = 'scrollbar-measure';
    document.body.appendChild(scrollDiv);

    // Get the scrollbar width & half width
    let scrollBarWidth = window.innerWidth - scrollDiv.clientWidth;
    let alignFullOffset = scrollBarWidth / 2;

    // console.log(window.innerWidth);
    // console.log(scrollDiv.clientWidth);
    // console.warn(scrollBarWidth); // Mac:  15

    // Delete the DIV
    document.body.removeChild(scrollDiv);

    //Get .alignfull element
    let root = document.documentElement;
    let root_style = getComputedStyle(root);

    //Set --alignfull-offset css var
    let cssVarAlignFullOffset = root_style.getPropertyValue('--alignfull-offset');
    if (alignFullOffset + 'px' !== cssVarAlignFullOffset) {
      root.style.setProperty('--alignfull-offset', alignFullOffset + 'px');
    }
  }

  //on load
  setAlignFullCssVar();

  $(window).resize(function () {
    setAlignFullCssVar();
  });
};
